module.exports = __webpack_public_path__ + "img/terroir-choppy-3.0393f455.jpg";